import { Field, Form, Formik } from "formik";
import { ScrollToFirstError } from "utils";
import { Button, Textarea, Checkbox } from "shared";
import { InvestmentItem } from "../../../types";
import { CurrenciesValues } from "./types";
import { currenciesSchema } from "./validationSchemas";
import { RELIANCE_CONSENT_TRANSACTIONS_LABEL } from "./constants";

interface CurrenciesFormProps {
  item: InvestmentItem;
  onSubmit: (values: CurrenciesValues) => void;
  onCancel: () => void;
  isPending: boolean;
  isAdmin?: boolean;
}

const CurrenciesForm = ({
  item,
  onSubmit,
  onCancel,
  isPending,
  isAdmin = false,
}: CurrenciesFormProps) => {
  const isReliance = item.origin === "reliance";
  const hideAdditionalInfo = !isAdmin && isReliance;
  const hideRelianceCanView = isAdmin && isReliance;
  const initialValues: CurrenciesValues = {
    additionalInfo: item.additionalInfo ?? "",
    relianceCanView: item.relianceCanView ?? false,
    status: item.status ?? "active",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={currenciesSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {(formik) => (
        <Form>
          <ScrollToFirstError />
          <div className="modal-form__fields">
            {!hideAdditionalInfo && (
              <Field
                component={Textarea}
                name="additionalInfo"
                label="Dodatkowe informacje"
                optional
              />
            )}

            {!hideRelianceCanView && (
              <Field
                as={Checkbox}
                name="relianceCanView"
                label={RELIANCE_CONSENT_TRANSACTIONS_LABEL}
                checked={formik.values.relianceCanView}
                onChange={() =>
                  formik.setFieldValue(
                    "relianceCanView",
                    !formik.values.relianceCanView,
                  )
                }
              />
            )}
          </div>

          <div className="modal-buttons">
            <Button
              type="button"
              className="button--stroke button--rounded"
              onClick={onCancel}
              label="Anuluj"
            />
            <Button
              type="submit"
              className="button--black button--rounded"
              onClick={() => {}}
              label={isPending ? "Zapisywanie..." : "Zapisz"}
              isLoading={isPending}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CurrenciesForm;
